import React from 'react';
import {getObject} from './services/storage-service';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import HomeScreen from './screens/home-screen';
import {NavigationContainer} from '@react-navigation/native';
import {AiFillHome} from 'react-icons/ai';
import MyMoviesScreen from './screens/my-movies-screen';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      favoriteMovies: [],
      watchedMovies: []
    }
    getObject('favoriteMovies').then((movies) => {
      if(movies === null) {
        movies = [];
      }
      this.setState({favoriteMovies: movies});
    });
    getObject('watchedMovies').then((movies) => {
      if(movies === null) {
        movies = [];
      }
      this.setState({watchedMovies: movies});
    });
  }

  render() {
    const Tab = createBottomTabNavigator();

    return (
        <NavigationContainer>
          <Tab.Navigator>
            <Tab.Screen name="Home" component={HomeScreen} options={{
              tabBarIcon: ({color, size}) => {
                return <AiFillHome name="home" color={color} size={size}/>
              }
            }}
            />
            <Tab.Screen name="MyMovies" component={MyMoviesScreen} options={{
              tabBarIcon: ({color, size}) => {
                return <AiFillHome name="home" color={color} size={size}/>
              }
            }}
            />
          </Tab.Navigator>
        </NavigationContainer>
    );
  }
}

export default App;
